import { history } from 'routes/history';

const formActions = require('react-redux-form').actions;
const preLoaderActions = require('./preLoaderActions');
const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');
const Storage = require('utilities/storage');
const actionTypes = require('constants/actionTypes');
const { CREDIT_CARD } = require('constants/userProfile');
import { formatText, getLanguage } from 'core/i18n';

const StringHelper = require('utilities/stringHelper');
const { getAliasesDocumentType, getReferenceCodeByCountry } = require('utilities/multiLanguageHelper');
const { BASE_PATH, ALLOW_COOKIE, PUBLICA_URL } = require('constants/index');

// @ utilities
import { errorTag, recordEventStepSuccess } from 'utilities/uTagging';

const { mustIncludeTinToRequest, mustShowTreatmentFields } = require('utilities/logicByCountry');
// @ constants
const { ERROR_EN_REGISTRO, ERROR_AL_REGISTRARSE_UN_INTERVINIENTE } = require('constants/analyticsErrors');
const { PATH_OPEN_YOUR_ACCOUNT } = require('constants/uTagConstants/paths');
const ORIGIN_COUNTRY = getReferenceCodeByCountry().toUpperCase();

const getBankID = () => `OK_${ORIGIN_COUNTRY}`;

const dateFormatNumber = number => {
    return number < 10 ? `0${parseInt(number)}` : number;
};

const getPrecontractualDocumentNamesAdapter = (documents = []) => {
    return documents.map(documentType => {
        return {
            documentName: formatText(`documents-${documentType}`),
            documentType,
            isAccepted: false,
            isRead: false,
        };
    });
};

const mergeDmsDocumentIdAdapter = (documentNames = [], dmsDocuments) => {
    return documentNames.map(document => {
        const foundDocument = dmsDocuments.find(dmsDocument => dmsDocument.documentType === document.documentType);

        return {
            ...document,
            ...(foundDocument && { dmsDocumentId: foundDocument.dmsDocumentId, checksum: foundDocument.checksum }),
        };
    });
};

const dniFormatNumber = (number, documentType) => {
    let docNumber = number;
    if (documentType === 'DNI') {
        const nZeros = 9 - docNumber.length;
        for (let i = 0; i < nZeros; i++) {
            docNumber = `0${docNumber}`;
        }
    }

    return docNumber;
};

const getIban = (dispatch, requestData, url, callback) => {
    Api.post(apiURLBuilder.getURL(url), requestData).then(
        response => {
            if (response.body) {
                dispatch(formActions.change('userProfile.accessToken', response.body.accessToken));
                dispatch(formActions.change('userProfile.refreshToken', response.body.refreshToken));
                dispatch(formActions.change('userProfile.name', response.body.name));
                dispatch(formActions.change('userProfile.lastName', response.body.lastname1));
                dispatch(formActions.change('userProfile.secondLastName', response.body.lastname2));
                dispatch(formActions.change('userProfile.iban', response.body.iban));
                dispatch(formActions.change('userProfile.showIban', true));
                dispatch(formActions.change('userProfile.recordId', response.body.footprint));
                dispatch(formActions.change('userProfile.product', response.body.product));
                dispatch(formActions.change('userProfile.userId', ''));
                dispatch(formActions.change('userProfile.embossingName', response.body.embossingName));

                if (ALLOW_COOKIE) {
                    const expires = new Date(new Date().getTime() + 45 * 60 * 1000);
                    Storage.cookies.set('accessToken', response.body.accessToken, { expires });
                    Storage.cookies.set('refreshToken', response.body.refreshToken, { expires });
                }

                recordEventStepSuccess(
                    requestData?.query?.investmentType,
                    '/onboarding/abre-tu-cuenta',
                    'abre tu cuenta'
                );
                dispatch({ type: actionTypes.INITIAL_STEP_COMPLETED });
                callback(true);
            }
        },
        error => {
            dispatch(preLoaderActions.hidePreLoader());

            let routeToDispatch = '/errors',
                categoryTag = ERROR_EN_REGISTRO;

            if (!error.body.errors) {
                history.push(BASE_PATH + routeToDispatch);

                return;
            }

            if (error.body.errors[6000] && requestData.query.token) {
                routeToDispatch = '/cuentaconjunta/error';
                categoryTag = ERROR_AL_REGISTRARSE_UN_INTERVINIENTE;
            } else if (error.body.errors[9012] || (error.body.errors[6000] && !!requestData.query.token)) {
                routeToDispatch = '/newProducts';
            } else if (error.body.errors[8002]) {
                dispatch(formActions.change('userProfile.errorIconClass', 'icons icons--icon-warning'));
                dispatch(
                    formActions.change(
                        'userProfile.errorTitle',
                        formatText('messagesScreen-onlyOneOnboardingErrorTitle', [requestData.query.name])
                    )
                );
                dispatch(
                    formActions.change('userProfile.errorContent', 'messagesScreen-onlyOneOnboardingErrorContent')
                );
                dispatch(formActions.change('userProfile.buttonText', formatText('button-understood')));
                dispatch(formActions.change('userProfile.buttonClass', 'form__button form__button-secondary'));
            } else if (error.body.errors[8020] || error.body.errors[8022]) {
                dispatch(formActions.change('userProfile.errorIconClass', 'icons icons--icon-warning'));
                dispatch(formActions.change('userProfile.errorTitle', formatText('messagesScreen-defaultErrorTitle')));
                dispatch(formActions.change('userProfile.errorSubtitle', ''));
                dispatch(formActions.change('userProfile.errorContent', 'messagesScreen-defaultErrorContent'));
                dispatch(formActions.change('userProfile.buttonText', formatText('button-understood')));
                dispatch(formActions.change('userProfile.buttonClass', 'form__button form__button-primary'));
            } else if (error.body.errors[8021]) {
                dispatch(formActions.change('userProfile.errorIconClass', 'icons icons--icon-warning'));
                dispatch(formActions.change('userProfile.errorTitle', formatText('messagesScreen-defaultErrorTitle')));
                dispatch(formActions.change('userProfile.errorSubtitle', ''));
                dispatch(formActions.change('userProfile.errorContent', 'messagesScreen-defaultErrorContent'));
                dispatch(formActions.change('userProfile.buttonText', formatText('button-understood')));
                dispatch(formActions.change('userProfile.buttonClass', 'form__button form__button-primary'));
            }
            errorTag(error.body, PATH_OPEN_YOUR_ACCOUNT, categoryTag, error.statusCode);
            dispatch(formActions.change('userProfile.errorIconClass', 'icons icons--icon-warning'));
            dispatch(formActions.change('userProfile.errorTitle', formatText('messagesScreen-defaultErrorTitle')));
            dispatch(formActions.change('userProfile.errorSubtitle', ''));
            dispatch(formActions.change('userProfile.errorContent', 'messagesScreen-registerErrorContent'));
            dispatch(formActions.change('userProfile.injectedContentValue', [`${PUBLICA_URL}he-olvidado-mi-clave`]));
            dispatch(formActions.change('userProfile.buttonText', formatText('button-understood')));
            dispatch(formActions.change('userProfile.buttonClass', 'form__button form__button-primary'));
            history.push(BASE_PATH + routeToDispatch);
        }
    );
};

const saveNoResidentPost = (dispatch, requestData) => {
    Api.post(apiURLBuilder.getURL('nonResident'), requestData).then(() => {
        dispatch({ type: actionTypes.HIDE_SPINNER });
    });
};

const saveCallMeBackPost = (dispatch, requestData, callback) => {
    Api.post(apiURLBuilder.getURL('PostCallMeBack'), requestData).then(data => {
        callback(data.body.idCallmeback);
    });
};

const saveResponseRequest = (dispatch, data, wealth, isRegisterV2Active, callback) => {
    let wealthCode = null;
    let wealthName = null;
    let wealthSecId = null;
    let wealthType = null;

    if (wealth) {
        wealthCode = wealth.get('wealthCode');
        wealthName = wealth.get('wealthName');
        wealthSecId = wealth.get('wealthSecId') ? wealth.get('wealthSecId') : '';
        wealthType = wealth.get('wealthType');
    }

    let type,
        subtype,
        standard = null;

    if (data.investmentType === CREDIT_CARD) {
        type = data.productType;
        subtype = data.productSubtype;
        standard = data.productStandard;
    }
    const saveRequestData = {
        header: {},
        query: {
            asnef: true,
            acceptedText: data.acceptedText,
            onboardingType: data.onboardingType,
            uuid: data.precontractualDocsId,
            documentationAcceptanceData: data.saveTimeDocAccept,
            birthdate: `${dateFormatNumber(data.birthDay)}/${dateFormatNumber(data.birthMonth)}/${data.birthYear}`,
            checkOpenCredit: data.creditCardOffer_accepted || false,
            cirbe: false,
            docNumber: dniFormatNumber(data.docNumber, data.documentType),
            docType: getAliasesDocumentType(data.documentType),
            email: data.email,
            intdb: true,
            language: getLanguage(),
            lastname1: StringHelper.toFirstUppercase(data.lastName),
            lastname2:
                data.secondLastName && data.secondLastName.length
                    ? StringHelper.toFirstUppercase(data.secondLastName)
                    : null,
            legal: true,
            name: StringHelper.toFirstUppercase(data.name),
            password: data.password,
            promotionalCode: data.promoCode || '',
            tgss: false,
            wealthCode,
            wealthName,
            wealthSecId,
            wealthType,
            investmentType: data.investmentType,
            type,
            subtype,
            standard,
            recaptcha: data.recaptcha,
            ...(data.nationality && { nationality: data.nationality }),
            ...(isRegisterV2Active && { passport: data.passport ?? '' }),
        },
    };

    if (mustShowTreatmentFields()) saveRequestData.query.treatment = data.treatment;

    if (mustIncludeTinToRequest()) saveRequestData.query.tin = data.tin;
    const url = isRegisterV2Active ? 'registerV2' : 'register';
    getIban(dispatch, saveRequestData, url, callback);
};

const saveJointHolderResponseRequest = (dispatch, data, isRegisterV2Active, callback) => {
    const saveRequestData = {
        header: {},
        query: {
            acceptedText: data.acceptedText,
            onboardingType: data.onboardingType,
            uuid: data.precontractualDocsId,
            documentationAcceptanceData: data.saveTimeDocAccept,
            name: StringHelper.toFirstUppercase(data.name),
            lastname1: StringHelper.toFirstUppercase(data.lastName),
            lastname2:
                typeof data.secondLastName !== 'undefined' && data.secondLastName.length
                    ? StringHelper.toFirstUppercase(data.secondLastName)
                    : null,
            docType: getAliasesDocumentType(data.documentType),
            docNumber: dniFormatNumber(data.docNumber, data.documentType),
            email: data.email,
            password: data.password,
            birthdate: `${dateFormatNumber(data.birthDay)}/${dateFormatNumber(data.birthMonth)}/${data.birthYear}`,
            asnef: true,
            tgss: false,
            cirbe: false,
            intdb: true,
            legal: true,
            token: data.jointHolderData.token,
            language: getLanguage(),
            checkOpenCredit: data.creditCardOffer_accepted || false,
            ...(data.nationality && { nationality: data.nationality }),
            ...(isRegisterV2Active && { passport: data.passport ?? '' }),
        },
    };

    if (mustIncludeTinToRequest()) saveRequestData.query.tin = data.tin;
    const url = isRegisterV2Active ? 'jointHolderRegisterV2' : 'jointHolderRegister';
    getIban(dispatch, saveRequestData, url, callback);
};

const saveNoResident = (dispatch, data) => {
    const saveRequestData = {
        header: {},
        query: {
            email: data.residentEmail,
            lastname1: data.lastName,
            lastname2: data.secondLastName,
            name: data.name,
            birthdate: `${dateFormatNumber(data.birthDay)}/${dateFormatNumber(data.birthMonth)}/${data.birthYear}`,
            nationality: data.resident,
        },
    };
    saveNoResidentPost(dispatch, saveRequestData);
};

const saveCallMeBack = (dispatch, data, callback) => {
    const saveRequestData = {
        header: {},
        query: data,
    };
    saveCallMeBackPost(dispatch, saveRequestData, callback);
};

const saveRegisterRequest = (data, wealth, isRegisterV2Active, callback) => {
    return dispatch => {
        saveResponseRequest(dispatch, data, wealth, isRegisterV2Active, callback);
    };
};

const saveJointHolderRegisterRequest = (data, isRegisterV2Active, callback) => {
    return dispatch => {
        saveJointHolderResponseRequest(dispatch, data, isRegisterV2Active, callback);
    };
};

const saveNoResidentRequest = data => {
    return dispatch => {
        saveNoResident(dispatch, data);
    };
};

const saveCallMEBackRequest = (data, callback) => {
    return dispatch => {
        saveCallMeBack(dispatch, data, callback);
    };
};

const cancelOnBoardingProcess = () => {
    return () => {
        return !!Storage.cookies.get('showModal');
    };
};

const documentationIsLoaded = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.IS_LOADED_IN_DOCUMENTATION,
        });
    };
};

const setFromInitialStep = value => {
    return dispatch => {
        dispatch({
            type: actionTypes.FROM_INITIAL_STEP,
            value,
        });
    };
};

const preContractualInfoService = (dispatch, responseId, requestData, callback) => {
    Api.get(apiURLBuilder.getURL('getInfoPrecontractual'), requestData).then(response => {
        response.body.response.map(data => {
            data.id = responseId;
            dispatch({
                type: actionTypes.LOAD_CONTRACTUAL_INFO,
                data: [data],
            });
        });
        if (callback !== null) callback();
    });
};

const getPreContractualInfoBuild = (dispatch, data, callback) => {
    dispatch({
        type: actionTypes.CLEAR_CONTRACTUAL_INFO,
    });

    for (let i = 0; i < data.length; i++) {
        const responseId = i;
        const requestData = {
            header: {},
            query: {
                tipo: parseInt(data[i].type),
                subtipo: parseInt(data[i].subtype),
                estandar: parseInt(data[i].standar),
                idioma: parseInt(data[i].language),
            },
        };

        preContractualInfoService(dispatch, responseId, requestData, callback);
    }
};

const getPreContractualInfo = (requestData, callback = null) => {
    return dispatch => {
        getPreContractualInfoBuild(dispatch, requestData, callback);
    };
};

const getAllPdfsByUUIDAndDocumentIdService = (dispatch, documentNames, callback) => {
    dispatch(preLoaderActions.showPreLoader());
    Promise.all(
        documentNames.map(document =>
            Api.post(
                apiURLBuilder.getURL('precontractualDocumentPDF'),
                {
                    header: {},
                    query: { documentId: document.dmsDocumentId },
                },
                'application/json',
                'application/json'
            )
        )
    )
        .then(responses => {
            const isSomeResponseWithError = responses.some(response => response.body.status !== 'OK');
            if (isSomeResponseWithError) throw new Error('Error getting document base64');
            const documents = responses.map((response, index) => ({
                ...documentNames[index],
                title: `${documentNames[index].documentName}. (${index + 1}/${documentNames.length})`,
                file: `data:application/pdf;base64,${response.body.file}`,
            }));
            dispatch(formActions.change('userProfile.precontractualDocNames', documents));
            dispatch(preLoaderActions.hidePreLoader());
            dispatch(formActions.change('userProfile.precontractualDocsOK', true));
            callback && callback(documents);
        })
        .catch(() => {
            dispatch(preLoaderActions.hidePreLoader());
            dispatch({ type: actionTypes.SET_CALLBACK_GLOBAL_ERROR_MODAL, data: '' });
            dispatch({ type: actionTypes.SHOW_GLOBAL_ERROR_MODAL, data: true });
        });
};

const getPrecontractualDocumentNamesService = (dispatch, requestData) => {
    dispatch(preLoaderActions.showPreLoader());

    Api.get(apiURLBuilder.getURL('precontractualDocuments'), requestData)
        .then(response => {
            if (response.status === 200) {
                dispatch(preLoaderActions.hidePreLoader());
                const documents = getPrecontractualDocumentNamesAdapter(response.body?.documents);
                dispatch(formActions.change('userProfile.precontractualDocNames', documents));
            } else {
                dispatch(preLoaderActions.hidePreLoader());
                dispatch({ type: actionTypes.SET_CALLBACK_GLOBAL_ERROR_MODAL, data: '' });
                dispatch({ type: actionTypes.SHOW_GLOBAL_ERROR_MODAL, data: true });

                return;
            }
        })
        .catch(() => {
            dispatch(preLoaderActions.hidePreLoader());
            dispatch({ type: actionTypes.SET_CALLBACK_GLOBAL_ERROR_MODAL, data: '' });
            dispatch({ type: actionTypes.SHOW_GLOBAL_ERROR_MODAL, data: true });
        });
};

const getPrecontractualProcessDocuments = (
    dispatch,
    getState,
    processId,
    callback,
    counterLoop,
    endProcessCallback
) => {
    const actualState = getState();
    if (actualState.userProfile.precontractualDocsId != processId) {
        dispatch({ type: actionTypes.HIDE_SPINNER });

        return;
    }
    const params = {
        processId,
    };

    return Api.get(apiURLBuilder.getURL('precontractualProcessDocuments', params))
        .then(response => {
            const { operationProcessStatus, documents } = response.body;
            if (operationProcessStatus === 'ERROR') {
                dispatch({ type: actionTypes.HIDE_SPINNER });
                dispatch({ type: actionTypes.SET_CALLBACK_GLOBAL_ERROR_MODAL, data: '' });
                dispatch({ type: actionTypes.SHOW_GLOBAL_ERROR_MODAL, data: true });

                return;
            }
            if (operationProcessStatus === 'PENDING') {
                const loop = counterLoop ? counterLoop : 0;
                if (loop > 18) {
                    dispatch({ type: actionTypes.HIDE_SPINNER });
                    dispatch({ type: actionTypes.SET_CALLBACK_GLOBAL_ERROR_MODAL, data: '' });
                    dispatch({ type: actionTypes.SHOW_GLOBAL_ERROR_MODAL, data: true });
                } else {
                    setTimeout(() => {
                        callback(dispatch, getState, processId, callback, loop + 1, endProcessCallback);
                    }, 500);
                }
            } else if (operationProcessStatus === 'COMPLETED' || operationProcessStatus === 'DOCUMENTS_COMPLETED') {
                const documentNames = actualState.userProfile.precontractualDocNames;
                const newDocumentNames = mergeDmsDocumentIdAdapter(documentNames, documents);
                if (actualState?.userProfile?.isAlreadyClient) {
                    const accessToken = actualState.userProfile.accessToken;
                    const request = {
                        header: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                        query: {
                            operationProcessId: params.processId,
                        },
                    };
                    Api.post(apiURLBuilder.getURL('alreadyClientConsolidation'), request).then(
                        () => {
                            return endProcessCallback && endProcessCallback();
                        },
                        () => {
                            history.push(`${BASE_PATH}/errors`);
                        }
                    );
                }
                getAllPdfsByUUIDAndDocumentIdService(dispatch, newDocumentNames, endProcessCallback);
            } else {
                dispatch({ type: actionTypes.HIDE_SPINNER });

                return;
            }
        })
        .catch(() => {
            dispatch({ type: actionTypes.HIDE_SPINNER });
            dispatch({ type: actionTypes.SET_CALLBACK_GLOBAL_ERROR_MODAL, data: '' });
            dispatch({ type: actionTypes.SHOW_GLOBAL_ERROR_MODAL, data: true });

            return;
        });
};

const precontractualProcessService = (dispatch, getState, requestData, processType, endProcessCallback) => {
    Api.post(apiURLBuilder.getURL('precontractualProcess'), requestData, 'application/json', 'application/json')
        .then(response => {
            if (response.body.operationProcessId) {
                dispatch(
                    formActions.change('userProfile.acceptedText', formatText('field-acceptClausulePrecontractual'))
                );
                dispatch(formActions.change('userProfile.onboardingType', processType));
                dispatch(formActions.change('userProfile.precontractualDocsId', response.body.operationProcessId));
                getPrecontractualProcessDocuments(
                    dispatch,
                    getState,
                    response.body.operationProcessId,
                    getPrecontractualProcessDocuments,
                    null,
                    endProcessCallback
                );
            } else {
                dispatch({ type: actionTypes.HIDE_SPINNER });
                dispatch({ type: actionTypes.SET_CALLBACK_GLOBAL_ERROR_MODAL, data: '' });
                dispatch({ type: actionTypes.SHOW_GLOBAL_ERROR_MODAL, data: true });

                return;
            }
        })
        .catch(() => {
            dispatch({ type: actionTypes.HIDE_SPINNER });
            dispatch({ type: actionTypes.SET_CALLBACK_GLOBAL_ERROR_MODAL, data: '' });
            dispatch({ type: actionTypes.SHOW_GLOBAL_ERROR_MODAL, data: true });
        });
};

const getPdfMergeService = (dispatch, requestData, callback) => {
    Api.post(apiURLBuilder.getURL('getPdfMerged'), requestData, 'application/json', 'application/json').then(
        response => {
            if (response.body.status === 'OK') {
                dispatch({
                    type: actionTypes.GET_PDF_MERGED,
                    data: response.body.file,
                });
                callback(true);
            } else {
                callback(false);
            }
        },
        () => {
            callback(false);
        }
    );
};

const getPdfMerge = (data, callback) => {
    return dispatch => {
        const requestData = {
            header: {},
            query: {
                urls: data,
            },
        };
        getPdfMergeService(dispatch, requestData, callback);
    };
};

const clearPdf = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.CLEAR_PDF_MERGED,
        });
    };
};

const tinVerifyService = (country, tin, callback) => {
    const url = apiURLBuilder.getURL('verifyTin', { country, tin });
    Api.get(url).then(
        () => {
            callback({ isValid: true });
        },
        ({ statusCode }) => {
            const isInvalidCountry = statusCode === 412;
            const isInvalidTin = statusCode === 404;

            callback({ isValid: false, isInvalidCountry, isInvalidTin });
        }
    );
};

const tinVerify = (country, tin, callback) => {
    return () => {
        tinVerifyService(country, tin, callback);
    };
};

const precontractualProcess = (processType, openDebitCard = true, url, endProcessCallback, recaptcha) => {
    return (dispatch, getState) => {
        const metadata = {
            originCountry: ORIGIN_COUNTRY,
            openDebitCard,
            ...(url && { url }),
        };
        const query = {
            recaptcha,
            processType,
            metadata,
        };
        const requestData = {
            header: {
                bankId: getBankID(),
            },
            query,
        };
        precontractualProcessService(dispatch, getState, requestData, processType, endProcessCallback);
    };
};

const getPrecontractualDocumentNames = (processType, openDebitCard = true) => {
    const requestData = {
        header: {
            bankId: getBankID(),
        },
        query: {
            processType,
            originCountry: ORIGIN_COUNTRY,
            openDebitCard,
        },
    };

    return dispatch => {
        getPrecontractualDocumentNamesService(dispatch, requestData);
    };
};

export default {
    saveRegisterRequest,
    saveJointHolderRegisterRequest,
    saveNoResidentRequest,
    saveCallMEBackRequest,
    cancelOnBoardingProcess,
    getPreContractualInfo,
    documentationIsLoaded,
    getPdfMerge,
    clearPdf,
    tinVerify,
    setFromInitialStep,
    tinVerifyService,
    precontractualProcess,
    getPrecontractualDocumentNames,
};
